import { useState } from "react";
import apiRequest from "../utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications/dist/ToastProvider.js";
import { useContent } from "../contexts/contentContext/contentContext.js";

const useJumboFormsCall = ({ mailData }) => {
  const [apiLoading, setApiLoading] = useState(false);
  const [ftpLoading, setFtpLoading] = useState(false);
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();

  const apiCall = async () => {
    setApiLoading(true);
    const response = await apiRequest(
      "Mails",
      "ReactSendAPIMail",
      { deliveryNumber: mailData.deliveryNumber },
      "POST"
    );
    if (response.status === "success") {
      addToast(getTextByKey("api-call-success"), {
        appearance: "success",
      });
    } else {
      addToast(getTextByKey("ftp-api-call-error"), {
        appearance: "error",
      });
    }
    setApiLoading(false);
  };

  const ftpCall = async () => {
    setFtpLoading(true);
    const response = await apiRequest(
      "Mails",
      "ReactSendFTPMail",
      { deliveryNumber: mailData.deliveryNumber },
      "POST"
    );
    if (response.status === "success") {
      addToast(getTextByKey("ftp-call-success"), {
        appearance: "success",
      });
    } else {
      addToast(getTextByKey("ftp-api-call-error"), {
        appearance: "error",
      });
    }
    setFtpLoading(false);
  };

  return {
    apiCall,
    ftpCall,
    apiLoading,
    setApiLoading,
    ftpLoading,
    setFtpLoading,
  };
};
export default useJumboFormsCall;
